export default __webpack_public_path__ + "static/media/MagnetometerImg.b8245048.jpg";